// src/components/operationCenter/widgets/EconomicCalendarWidget.tsx
// Compact Economic Calendar widget for Operation Center

import React, { useState } from "react";
import { Calendar } from "lucide-react";
import type { WidgetProps } from "@/types/dashboard";
import { EconomicCalendarView } from "@/components/macro";

const EconomicCalendarWidget: React.FC<WidgetProps> = () => {
  const [viewMode, setViewMode] = useState<'upcoming' | 'recent'>('upcoming');

  return (
    <div className="h-full flex flex-col overflow-hidden">
      {/* Header with toggle at top right */}
      <div className="flex items-center justify-between px-3 py-2 border-b border-slate-700/50 bg-slate-800/30 flex-shrink-0">
        <div className="flex items-center gap-2">
          <Calendar className="w-3.5 h-3.5 text-purple-400" />
          <span className="text-xs uppercase tracking-wide text-slate-300">
            Economic Calendar
          </span>
        </div>
        {/* Toggle */}
        <div className="flex items-center bg-slate-800/60 rounded-md p-0.5">
          <button
            onClick={() => setViewMode('upcoming')}
            className={`px-2 py-0.5 text-[10px] font-medium rounded transition-colors ${
              viewMode === 'upcoming'
                ? 'bg-purple-500/80 text-white'
                : 'text-slate-400 hover:text-white'
            }`}
          >
            Upcoming
          </button>
          <button
            onClick={() => setViewMode('recent')}
            className={`px-2 py-0.5 text-[10px] font-medium rounded transition-colors ${
              viewMode === 'recent'
                ? 'bg-purple-500/80 text-white'
                : 'text-slate-400 hover:text-white'
            }`}
          >
            Recent
          </button>
        </div>
      </div>

      {/* Calendar content - reuses the main component */}
      <div className="flex-1 overflow-hidden min-h-0 p-2">
        <EconomicCalendarView
          accentColor="purple"
          compact
          showHeader={false}
          viewMode={viewMode}
          onViewModeChange={setViewMode}
          maxEventsPerDate={5}
          maxDateGroups={10}
        />
      </div>
    </div>
  );
};

export default EconomicCalendarWidget;
